import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Skeleton loading state matching the ERPIntegrationSettingsPanel layout.
 * Shows placeholder rows for the sync jobs section.
 * @returns Skeleton layout element
 */
export function ERPSettingsSkeleton() {
  return (
    <div className="space-y-6 pt-4">
      <div className="flex items-center justify-between">
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-8 w-24 rounded-md" />
      </div>
      <SyncCardSkeleton />
      <SyncCardSkeleton />
    </div>
  );
}

/**
 * Skeleton placeholder shaped to match a single SyncCard's header, summary
 * grid, and footer. Keeps loading state visually faithful to the populated UI.
 * @returns Skeleton card element
 */
function SyncCardSkeleton() {
  return (
    <Card className="overflow-hidden shadow-sm">
      <div className="flex items-center justify-between border-b bg-muted/30 px-4 py-3">
        <div className="space-y-1.5">
          <Skeleton className="h-4 w-36" />
          <Skeleton className="h-3 w-52" />
        </div>
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>
      <div className="grid grid-cols-[max-content_1fr] gap-x-4 gap-y-2 px-4 py-3">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-3 w-16" />
      </div>
      <div className="flex items-center justify-between border-t bg-muted/20 px-4 py-3">
        <Skeleton className="h-3 w-40" />
        <div className="flex gap-1.5">
          <Skeleton className="h-8 w-16 rounded-md" />
          <Skeleton className="h-8 w-20 rounded-md" />
          <Skeleton className="h-8 w-20 rounded-md" />
        </div>
      </div>
    </Card>
  );
}
